<script setup lang="ts">
const boardColumns = [
  [56, 40],
  [56, 40, 40],
  [56, 40],
];
</script>

<template>
  <div
    class="font-pds bg-papier no-scrollbar flex h-[100dvh] w-full overflow-y-auto"
  >
    <aside
      class="bg-pan border-filet hidden h-full w-[520px] shrink-0 flex-col justify-between border-r p-12 lg:flex"
    >
      <div class="flex items-center gap-[14px]">
        <div
          class="bg-pan-encre text-pan flex size-12 items-center justify-center rounded-full text-[18px] leading-[22px] font-bold"
        >
          N
        </div>
        <div class="text-pan-encre flex flex-col gap-[2px]">
          <span class="text-[18px] leading-[22px] font-bold">PDS</span>
          <span class="text-[12px] leading-[17px]">Poste de préparation</span>
        </div>
      </div>

      <div class="text-pan-encre flex flex-col gap-[10px]">
        <p class="text-[28px] leading-[34px] font-bold">
          Les commandes arrivent ici.
        </p>
        <p class="text-[14px] leading-5 opacity-72">
          Vous les préparez, le client est prévenu quand c’est prêt.
        </p>
      </div>

      <div class="flex gap-3" aria-hidden="true">
        <div
          v-for="(column, i) in boardColumns"
          :key="i"
          class="flex min-w-0 flex-1 flex-col gap-[10px]"
        >
          <div class="bg-pan-encre h-2 w-11 rounded-full opacity-45"></div>
          <div
            v-for="(height, j) in column"
            :key="j"
            class="bg-pan-relief w-full rounded-[10px]"
            :style="{ height: `${height}px` }"
          ></div>
        </div>
      </div>
    </aside>

    <main class="flex min-w-0 flex-1 items-center justify-center px-4 lg:px-14">
      <div
        class="flex w-[420px] max-w-full flex-col items-center gap-5 p-4 sm:p-8"
      >
        <slot />
      </div>
    </main>
  </div>
</template>
